import axios from 'axios'
import Qs from 'qs'
import { parse, stringify } from 'qs'

import {
	clientStorageLocal,
	LOCAL_STORAGE_AUTH_ACCESS_TOKEN_KEY,
} from '@ao/utils'

const getHref = () => {
	return window?.location.href || null
}

/**
 * @param {object} options - axios options
 * @param {string} options.url - endpoint
 * @param {string} [options.method=GET] - default - GET
 * @param {object} [options.params] - params
 * @param {object} [options.body] - body
 * @param {object} [options.headers] - body
 * @returns {Promise} Promise object
 */
export function request(options) {
	const token = clientStorageLocal.get(LOCAL_STORAGE_AUTH_ACCESS_TOKEN_KEY)

	const href = getHref()

	let axiosConfig = {
		method: 'GET',
		url: '',
		params: {},
		body: null,
		headers: {
			'Content-Type': 'application/json'
			// 'Content-Language': i18n.locale, //TODO: добавлять ключ локали в запрос
		},
		...options,
	}

	// RISK(RISK-006)[S2/безопасность]: axios 0.27.2 устарел (20 CVE, вкл. утечку auth-заголовков
	// на absolute URL и SSRF). Решение: обновить до axios 1.x (модуль без interceptors — правка дешёвая).
	// RISK(RISK-008 связь)[S2/безопасность]: X-Custom-Referer уносит полный URL страницы (с query)
	// в заголовке на бэкенд — потенциальная утечка чувствительных параметров в логи сервера.
	// Подробнее: docs/audit/04_risks_register.md (RISK-006)
	if (href) {
		axiosConfig.headers['X-Custom-Referer'] = href
	}

	if (token && token !== 'undefined') axiosConfig.headers['Authorization'] = `Bearer ${token}`

	return new Promise((resolve, reject) => {
		axios({
			method: axiosConfig.method,
			url: axiosConfig.url,
			params: axiosConfig.params,
			paramsSerializer: function (params) {
				return Qs.stringify(params, {arrayFormat: 'comma'})
			},
			headers: axiosConfig.headers,
			data: axiosConfig.body,
		})
			.then((res) => {
				resolve(res.data)
			})
			.catch((error) => {
				reject(error)
			})
	})
}
